<template>
  <div>
    <el-form :model="form" :rules="rules" ref="form" :validate-on-rule-change="false">
      <div class="row mt-5">
        <div class="col-12 col-sm-8 pr-sm-0">
          <el-form-item prop="title">
            <el-input v-model="form.title" />
            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.title) }">Описание</span>
          </el-form-item>
        </div>
        <div class="col-12 col-sm-4 d-flex align-items-center">
          <el-form-item prop="active">
            <div class="d-flex align-items-center">
              <el-switch :value="form.active" @change="form.active = !form.active"/>
              <span class="ml-2">Отображать на главном экране</span>
            </div>
          </el-form-item>
        </div>

        <div class="col-12 col-sm-8 pr-sm-0">
          <el-form-item prop="title">
            <el-input v-model="form.link" />
            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.link) }">Ссылка на ImShop</span>
          </el-form-item>
        </div>

        <div class="col-12 col-sm-6 pr-sm-0">
          <div class="text-small mb-1">Изображение</div>
          <el-form-item prop="picture">
            <el-upload ref="upload_picture_title" class="w-100" drag action="/" accept="image/*" :show-file-list="false" :auto-upload="false"
                       :on-change="onChangePictureUrl">
              <img v-if="form.picture && form._pictureUrl" :src="form._pictureUrl" class="loaded-image">
              <template v-else>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  Перетащите файл или <em>нажмите для загрузки</em>
                </div>
              </template>
              <div class="text-small text-danger" slot="tip">Текущее изображение удаляется и заменяется новым</div>
            </el-upload>
          </el-form-item>
        </div>
      </div>
    </el-form>

    <div class="row mt-4">
      <div class="col-12">
        <el-button type="primary" :loading="actionProgress" @click="onSubmit">{{submitBtnText}}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { MESSAGES } from '@/commons/constants/errorMessages';

const initialForm = () => ({
  title: '',
  link: '',
  picture: '',
  _pictureUrl: '',
  active: false,
});
export default {
  data() {
    return {
      form: initialForm(),
    };
  },
  created() {
    this.fillForm();
  },

  computed: {
    ...mapGetters({
      item: 'marketingBlocks/item',
      actionProgress: 'marketingBlocks/actionProgress',
    }),
    rules() {
      const requiredRule = [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }];

      const rules = {
        title: requiredRule,
        picture: requiredRule,
        link: requiredRule,
      };
      return rules;
    },
    isEditMode() {
      return !!this.item?.id;
    },
    title() {
      return this.isEditMode ? 'Редактировать блок' : 'Новый блок';
    },
    submitBtnText() {
      return this.isEditMode ? 'Сохранить блок' : 'Создать блок';
    },
  },

  methods: {
    ...mapMutations({
      addNotifyErrors: 'notifications/addNotifyErrors',
    }),
    ...mapActions({
      createItem: 'marketingBlocks/createItem',
      updateItem: 'marketingBlocks/updateItem',
      uploadFile: 'files/uploadFile',

      // fetchItem: 'workouts/fetchItem',
      // setItemId: 'workouts/setItemId',

    }),
    beforeClose(done) {
      if (!this.actionProgress) {
        done();
      }
    },
    fillForm() {
      if (this.item) {
        Object.keys(this.form).forEach((key) => {
          switch (key) {
            case '_pictureUrl': { this.form[key] = this.item.picture; break; }
            default: this.form[key] = this.item[key];
          }
        });
      } else {
        this.form = initialForm();
      }
    },
    onChangeType(item) {
      this.$refs.form.clearValidate();
      this.form.type = item;
    },
    async onChangePictureUrl(file) {
      const formData = new FormData();
      formData.append('image', file.raw);
      const resp = await this.uploadFile({ formData, bucket: 'marketing' });

      if (resp.filename && resp.preview) {
        this.form.picture = resp.filename;
        this.form._pictureUrl = resp.preview;
      }
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const id = this.item?.id;
          const data = {
            ...this.form,
          };
          if (this.isEditMode && this.item.picture === this.form.picture) {
            delete data.picture;
          }
          delete data._pictureUrl;
          const method = this.isEditMode ? this.updateItem : this.createItem;
          method({ id, data })
            .then((resp) => {
              this.setItemId(resp.id);
              this.fetchItem();
            }).catch(() => {});
        }
      });
    },
  },
  watch: {
    item: {
      handler() {
        this.fillForm();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.loaded-image {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.six-picture {
  width: 300px;
  margin-left: auto;
  margin-right: auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 8px;
  background: black;
  border-radius: 12px;
  padding: 12px;
  &-item {
    &__image {
      position: relative;
      width: 100%;
      height: 52px;
      margin-bottom: 6px;
      border-radius: 12px;
      background-position: center;
      background-size: cover;
      background-color: #939393;
      &-close {
        color: white;
        font-size: 24px;
        line-height: 24px;
        position: absolute;
        right: -8px;
        top: -10px;
        cursor: pointer;
        background-color: black;
        border-radius: 50%;
      }
    }

    &__title {
      text-align: center;
      color: white;
      font-size: 10px;
    }
  }
}
</style>
